import { PARTNER_TYPES, PROFILE_TYPES, RECORD_TYPE } from '@/app/data/model_constants';

const CONTACT_TYPE_TO_ICON = Object.freeze({
  [PARTNER_TYPES.DECISION_PARTNER]: ['far', 'person-dolly'],
  [PARTNER_TYPES.PROJECT_PARTNER]: ['far', 'user-helmet-safety'],
  [PARTNER_TYPES.SALES_PARTNER]: 'handshake',
  [PROFILE_TYPES.CUSTOMER]: ['far', 'user-large'],
  [PROFILE_TYPES.EMPLOYEE]: ['far', 'user-group'],
  [PROFILE_TYPES.PARTNER]: 'users',
  [RECORD_TYPE.COMPANY]: 'building',
});

export default CONTACT_TYPE_TO_ICON;
